import { render, staticRenderFns } from "./Tema3.vue?vue&type=template&id=1004572c&lang=pug"
import script from "./Tema3.vue?vue&type=script&lang=js"
export * from "./Tema3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports